exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mobile-user-card{display:flex;font-family:Open Sans,sans-serif;position:relative}.mobile-user-card .user-avatar{height:75%;margin-top:0}.mobile-user-card__user-info{display:flex;flex-direction:column;margin-left:8px;max-width:calc(100% - 120px)}.mobile-user-card__user-info.from-popup{max-width:calc(100% - 28px)}.mobile-user-card__user-info .title-and-name{color:#333;font-size:16px;line-height:18px;max-height:37px;overflow:hidden;word-break:break-word;margin-bottom:2px}.mobile-user-card__user-info .email,.mobile-user-card__user-info .phone{display:flex;font-size:14px;color:#9b9b9b;line-height:20px;height:20px}.mobile-user-card__user-info .email img,.mobile-user-card__user-info .phone img{padding-top:2px;width:14px}.mobile-user-card__user-info .email p,.mobile-user-card__user-info .phone p{margin:0;max-width:calc(100% - 12px);overflow:hidden;text-overflow:ellipsis}.mobile-user-card__arrow{height:16px;width:auto;position:absolute;top:24px;right:24px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ProjectDetailsContainer/MobileUserCard/MobileUserCard.scss
// module id = 1779
// module chunks = 0